import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import Firebase from 'firebase/app';
import { NavLink } from 'react-router-dom';

import updateSubscription from '../../actions/updateSubscription';

import Logo from '../../assets/investor-scout-3-logo-full.svg';
import AppsumoLogo from '../../assets/appsumo-logo.svg';

export default function AppsumoUpgrade(props) {

  const { register, errors, handleSubmit } = useForm();
  const [error, setError] = useState("");
  const docRef = Firebase.firestore().collection("appsumoRedemption").doc("codes");

  const checkRedemption = (data) => {

    docRef.get().then(function(doc) {
      var code = data.redemptionCode;
      var allCodes = doc.data().allCodes;
      var redeemedCodes = doc.data().redeemedCodes;

      if (code) {
        if (allCodes.includes(code)) {
          if (redeemedCodes.includes(code)) {
            console.log("Code already redeemed");
            setError({message: "Code already redeemed"});
          } else {
            let plan = 4;
            signUp(plan, code, redeemedCodes);
          };
        } else {
          console.log("Your code is invalid");
          setError({message: "Your code is invalid"});        
        }
      };
    });
  }

  const signUp = (plan, code, redeemedCodes) => {
    var authUser = Firebase.auth().currentUser;
    if (authUser) {
      return Promise.all([
        updateSubscription(props.subscription.id, plan),
        redeemCode(code, redeemedCodes),
      ])
        .then( () => {
          props.history.push("/account");
        })
        .catch( error => {
          setError(error)
        });
    }
  }

  const redeemCode = (code, redeemedCodes) => {
    if (code) {
      redeemedCodes.push(code);
      docRef.update({'redeemedCodes': redeemedCodes});
    } else {
      console.log("optional code");
    }
  }

  const onSubmit = data => {
    if (data.redemptionCode) {
      checkRedemption(data);
    } else {
      setError({message: "Please enter your Appsumo code!"});
    };
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto text-center sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <NavLink to="/">
            <img className="mx-auto h-12 w-auto px-4" src={Logo} alt="InvestorScout" />
          </NavLink>
          <svg className="text-red-600 h-10 w-10 mx-2 fill-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <img className="mx-auto h-12 w-auto" src={AppsumoLogo} alt="Appsumo" />
        </div>
        <h2 className="mt-6 text-lg leading-9 font-bold text-gray-800">
          Hey Sumo-lings,
        </h2>
        <p className="mt-2 text-sm leading-5 text-gray-600 max-w">
          <span>Please enter your second AppSumo code to upgrade your plan</span>          
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-6">
              <label htmlFor="password" className="block text-sm font-medium leading-5 text-gray-700">
                AppSumo redemption code
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  name="redemptionCode"
                  id="redemptionCode"
                  type="text"
                  ref={register({ 
                    required: "This input is required.",
                    maxLength: {
                      value: 8,
                      message: "Your code is invalid"
                    },
                    minLength: {
                      value: 8,
                      message: "Your code is invalid"
                    }
                  })}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              {errors.redemptionCode && <p className="mt-2 text-sm text-red-600" id="redemption-error">{errors.redemptionCode.message}</p>}
            </div>

            <div className="mt-6">
              <span className="block w-full rounded-md shadow-sm">
                <button type="submit" className="w-full flex justify-center py-3 px-5 border border-transparent text-base font-bold rounded-lg text-white bg-investor-blue hover:opacity-75 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                  Upgrade now
                  <svg className="fill-current opacity-25 w-6 h-6 ml-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
              </span>
              {error && <p className="mt-2 text-sm text-red-600" id="error">{error.message}</p>}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
